// extracted by mini-css-extract-plugin
export var emptyState = "_7d-d";
export var statCard = "_7d-c";
export var table = "_7d-0";
export var tableCell = "_7d-4";
export var tableCellClickable = "_7d-5 _7d-4";
export var tableCellDefault = "_7d-6 _7d-4";
export var tableCellEmpty = "_7d-8";
export var tableCellWithValue = "_7d-7";
export var tableContainer = "_7d-e";
export var tableHeaderWeight = "_7d-1";
export var tableHeaderZone = "_7d-2";
export var tableRowHeader = "_7d-3";
export var viewModeButton = "_7d-9";
export var viewModeButtonActive = "_7d-a _7d-9";
export var viewModeButtonInactive = "_7d-b _7d-9";